export default __webpack_public_path__ + "static/media/logo.47a99321.svg";